{
  "es": {
    "start": "Empezar inventario",
    "inspectionType": "Tipo de inspección",
    "inspectionTypeHint": "Inicial = entrega. Final / retorno = para comparar al salir.",
    "initialType": "Entrega inicial",
    "finalType": "Retorno final",
    "address": "Dirección del piso",
    "owner": "Propietario",
    "propertyId": "ID de propiedad",
    "date": "Fecha",
    "inspector": "Inspector / Entrega *",
    "receiver": "Receptor / Recibe",
    "composition": "Composición del piso",
    "bedrooms": "Dormitorios",
    "bathrooms": "Baños",
    "catalogHint": "Se cargarán {rooms} estancias con {items} ítems del catálogo.",
    "inspectorRequired": "Indicá el nombre del inspector para empezar.",
    "toSummary": "Cerrar y ver resumen",
    "nextItem": "Siguiente ítem",
    "finishRoom": "Terminar {room}",
    "skipItem": "Dejarlo para luego",
    "itemList": "Lista",
    "askPresent": "¿Está en el piso?",
    "presentYes": "Sí",
    "presentNo": "No",
    "presentNotNeeded": "No es necesario",
    "askQuantity": "Cantidad",
    "askQuality": "Calidad",
    "askProvider": "¿Quién lo pone?",
    "askPhotos": "Fotos",
    "takePhoto": "Hacer una foto",
    "roomNeedsPhoto": "Falta 1 foto mínima de esta estancia",
    "addNotes": "+ Añadir observaciones",
    "notesWithValue": "Observaciones: {notes}",
    "catalogLabel": "Catálogo",
    "extraLabel": "Agregado en el piso",
    "addItemToRoom": "＋ Agregar ítem a {room}",
    "removeItemFromRoom": "✕ Quitar «{item}» de esta estancia",
    "addRoom": "＋ Agregar estancia",
    "addItemTitle": "Agregar ítem a {room}",
    "addItemSubmit": "Agregarlo y revisarlo",
    "addItemKeepAdding": "Agregar y seguir añadiendo",
    "addRoomTitle": "Agregar estancia",
    "addRoomHint": "Elige de qué tipo es, para que el catálogo encaje.",
    "addRoomWithCatalog": "Crear con los ítems del catálogo",
    "addRoomEmpty": "Crear vacía",
    "closeSheet": "Cerrar",
    "cancel": "Cancelar",
    "missingFlag": "{count} no está",
    "missingFlagPlural": "{count} no están",
    "badFlag": "{count} en mal estado",
    "reviewedOf": "{done} de {total} revisados",
    "summaryTitle": "Resumen del inventario",
    "tallyOk": "Correctos",
    "tallyDamaged": "Con daños",
    "tallyMissing": "No están",
    "tallyPending": "Pendientes",
    "pendingCard": "Sin revisar",
    "missingCard": "No están en el piso",
    "damagedCard": "Regular o mal estado",
    "allOkTitle": "Todo en orden",
    "allOkBody": "Los {count} ítems están presentes y en buen estado.",
    "backToRooms": "Volver al inventario",
    "ownerLine": "Propietario: {owner} · Inspector: {inspector} · Recibe: {receiver}"
  },
  "en": {
    "start": "Start inventory",
    "inspectionType": "Inspection type",
    "inspectionTypeHint": "Initial = handover. Final / return = for checkout comparison.",
    "initialType": "Initial handover",
    "finalType": "Final / return",
    "address": "Property address",
    "owner": "Owner",
    "propertyId": "Property ID",
    "date": "Date",
    "inspector": "Inspector / Handover *",
    "receiver": "Receiver",
    "composition": "Property layout",
    "bedrooms": "Bedrooms",
    "bathrooms": "Bathrooms",
    "catalogHint": "{rooms} rooms will be created with {items} catalog items.",
    "inspectorRequired": "Enter the inspector name to start.",
    "toSummary": "Close and view summary",
    "nextItem": "Next item",
    "finishRoom": "Finish {room}",
    "skipItem": "Skip for later",
    "itemList": "List",
    "askPresent": "Is it in the property?",
    "presentYes": "Yes",
    "presentNo": "No",
    "presentNotNeeded": "Not necessary",
    "askQuantity": "Quantity",
    "askQuality": "Condition",
    "askProvider": "Who provides it?",
    "askPhotos": "Photos",
    "takePhoto": "Take a photo",
    "roomNeedsPhoto": "At least 1 photo is required for this room",
    "addNotes": "+ Add notes",
    "notesWithValue": "Notes: {notes}",
    "catalogLabel": "Catalog",
    "extraLabel": "Added on site",
    "addItemToRoom": "+ Add item to {room}",
    "removeItemFromRoom": "✕ Remove “{item}” from this room",
    "addRoom": "+ Add room",
    "addItemTitle": "Add item to {room}",
    "addItemSubmit": "Add and review it",
    "addItemKeepAdding": "Add and keep adding",
    "addRoomTitle": "Add room",
    "addRoomHint": "Pick a type so the catalog matches.",
    "addRoomWithCatalog": "Create with catalog items",
    "addRoomEmpty": "Create empty",
    "closeSheet": "Close",
    "cancel": "Cancel",
    "missingFlag": "{count} missing",
    "missingFlagPlural": "{count} missing",
    "badFlag": "{count} in poor condition",
    "reviewedOf": "{done} of {total} reviewed",
    "summaryTitle": "Inventory summary",
    "tallyOk": "OK",
    "tallyDamaged": "Damaged",
    "tallyMissing": "Missing",
    "tallyPending": "Pending",
    "pendingCard": "Not reviewed",
    "missingCard": "Not in the property",
    "damagedCard": "Fair or poor condition",
    "allOkTitle": "All good",
    "allOkBody": "All {count} items are present and in good condition.",
    "backToRooms": "Back to inventory",
    "ownerLine": "Owner: {owner} · Inspector: {inspector} · Receiver: {receiver}"
  }
}
